import { Badge, Flex, Progress, Text } from "@chakra-ui/react";
import { PUBLISH_VISIBILITY } from "@root/constants";

export const CourseTableColumns = (
  onCourseClick: (course: any) => void,
  t: (key: string) => string
) => {
  return [
    {
      header: t("subscriberManagement.courseTitle"),
      accessorKey: "title",
      cell: (info: any) => (
        <Text
          fontWeight="500"
          fontSize="14px"
          color="#2F2F34"
          cursor="pointer"
          _hover={{ textDecoration: "underline" }}
          onClick={() => onCourseClick(info.row.original)}
        >
          {info?.row?.original?.course?.title}
        </Text>
      ),
    },
    {
      header: t("subscriberManagement.memberEnrolled"),
      accessorKey: "members",
      cell: (info: any) => (
        <Text fontSize="14px" fontWeight="500" color="#2F2F34">
          {info?.row?.original?.registeredUser}
        </Text>
      ),
    },
    {
      header: t("subscriberManagement.status"),
      accessorKey: "status",
      cell: (info: any) => {
        const status =
          info?.row?.original?.registeredUser === 0 &&
          info?.row?.original?.overallProgress === 0
            ? PUBLISH_VISIBILITY.UNASSIGNED
            : PUBLISH_VISIBILITY.ACTIVE;
        const label =
          status === PUBLISH_VISIBILITY.UNASSIGNED
            ? t("manageCourses.unassigned")
            : t("manageCourses.active");
        return (
          <Badge
            px="10px"
            py="2px"
            borderRadius="12px"
            fontSize="13px"
            fontWeight="500"
            colorScheme={
              status === PUBLISH_VISIBILITY.ACTIVE ? "green" : "orange"
            }
            bg={status === PUBLISH_VISIBILITY.ACTIVE ? "#EDFCF2" : "#FFF4E5"}
            color={status === PUBLISH_VISIBILITY.ACTIVE ? "#16A34A" : "#D97706"}
            w="fit-content"
          >
            ● {label}
          </Badge>
        );
      },
    },
    {
      header: t("subscriberManagement.completionRate"),
      accessorKey: "completionRate",
      cell: (info: any) => {
        const rate = info?.row?.original?.overallProgress ?? 0;
        return (
          <Flex direction="column" minW="120px">
            <Progress
              value={rate}
              size="sm"
              borderRadius="10px"
              bg="#E5E7EB"
              colorScheme="blue"
              mb="2px"
            />
            <Text fontSize="14px" fontWeight="500" color="#2F2F34">
              {rate}%
            </Text>
          </Flex>
        );
      },
    },
    {
      header: t("subscriberManagement.lastUpdated"),
      accessorKey: "lastUpdated",
      cell: (info: any) => {
        const rawDate = info?.row?.original?.updatedAt;
        const formattedDate = rawDate
          ? new Date(rawDate).toLocaleDateString("sv-SE") // gives YYYY-MM-DD format
          : "-";

        return (
          <Text fontSize="14px" color="#2F2F34">
            {formattedDate}
          </Text>
        );
      },
    },
  ];
};
